export const roles = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  SYSADMIN: '59a72bbd-9a43-427e-9c92-afd74ab19433',
};

export type RoleKey = keyof typeof roles;
